export const edificiosColumns = [
  {
    id: 'estado',
    label: 'Estado',
    type: 'select',
    sortable: true,
    required: true,
    options: [
      { value: 'Activo', label: 'Activo' },
      { value: 'Inactivo', label: 'Inactivo' },
    ]
  },
  {
    id: 'nombre',
    label: 'Nombre del Edificio',
    type: 'text',
    sortable: true,
    required: true
  },
  {
    id: 'ciudad',
    label: 'Ciudad',
    type: 'text',
    sortable: true,
    required: true
  },
  {
    id: 'direccion',
    label: 'Dirección',
    type: 'text',
    sortable: true,
    required: true
  },
  {
    id: 'numeroHospedajes',
    label: 'Número de Activos',
    type: 'number',
    sortable: true,
    required: true,
    min: 1
  },
  {
    id: 'tipo',
    label: 'Tipo de Edificio',
    type: 'select',
    sortable: true,
    required: true,
    options: [
      { value: 'casa', label: 'Casa(s)' },
      { value: 'apto', label: 'Apartamento(s)' },
      { value: 'otro', label: 'Otro' },
    ]
  },
  {
    id:'tipoLogistica',
    label:'Tipo Logística',
    type:'select',
    sortable:true,
    required:true,
    options:[
      {value:'horizontal',label:'Horizontal'},
      {value:'vertical',label:'Vertical'},
      {value:'mixto',label:'Mixto'},
    ]
  },
  {
    id: 'zona',
    label: 'Zona',
    type: 'select',
    sortable: true,
    required: false,
    options: [], // Se llenará dinámicamente desde EdificiosPage
  },
  {
    id: 'opciones',
    label: 'Opciones',
    width: '10%',
    actions: [
      {
        key: 'assign-garment-types',
        icon: 'Shirt',
        tooltip: 'Asignar tipos de prenda',
        className: 'text-blue-600 hover:text-blue-700',
      },
      {
        key: 'assign-insumos',
        icon: 'Package',
        tooltip: 'Asignar insumos',
        className: 'text-purple-600 hover:text-purple-700',
      },
      {
        key: 'edit',
        icon: 'Edit',
        tooltip: 'Editar edificio',
        className: 'text-muted-foreground hover:text-foreground',
      },
      {
        key: 'delete',
        icon: 'Trash',
        tooltip: 'Eliminar edificio',
        className: 'text-muted-foreground hover:text-foreground',
      },
    ],
  },
];

export const columnsExcel = [
  { id: 'nombre', label: 'Nombre del Portafolio' },
  { id: 'ciudad', label: 'Ciudad' },
  { id: 'direccion', label: 'Dirección' },
  { id: 'numeroHospedajes', label: 'Número de Activos' },
  { id: 'tipo', label: 'Tipo de Edificio' },
  { id: 'estado', label: 'Estado' },
];
